import FlexColumn from './components/FlexColumn';
import FlexRow from './components/FlexRow';
import FlexBox from './Flex';

const Flex = Object.assign(FlexBox, {
    Column: FlexColumn,
    Row: FlexRow
});

export default Flex;
